import React from "react";
import PropTypes from 'prop-types';
import { Row, Col } from "antd";

import { DownloadPDF, VanguardImage, ContributionWrapper } from "./styles";
import DBCard from "../../../../../../CommonComponents/Cards/DBCard/DBCard";
import Vanguard_Image from "../../../../../../assets/icons/logo-desktop.png";
import Vanguard_Mobile from "../../../../../../assets/icons/logo-mobile.png";

const DownloadContributions = ({link, handleDownloadAnalytics}) => {
  return (
    <Row>
      <Col lg={24} md={24} xs={0}>
        <DownloadPDF>
          <VanguardImage src={Vanguard_Image} alt="vangaurd_logo" />
          <ContributionWrapper>
            <DBCard link={link} handleDownloadAnalytics={handleDownloadAnalytics}/>
          </ContributionWrapper>
        </DownloadPDF>
      </Col>
      <Col lg={0} md={0} xs={24}>
        <DownloadPDF height="130px">
          <VanguardImage src={Vanguard_Mobile} alt="vangaurd_logo" />
          <ContributionWrapper>
            <DBCard link={link} handleDownloadAnalytics={handleDownloadAnalytics}/>
          </ContributionWrapper>
        </DownloadPDF>
      </Col>
    </Row>
  );
};

export default DownloadContributions;

DownloadContributions.propTypes = {
  link: PropTypes.string,
  handleDownloadAnalytics: PropTypes.func,
};